import {
    Form,
    Input,
    Row,
    Col,
    Select,
    DatePicker,
    Switch,
} from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import dayjs from 'dayjs';
import GeneralMultiSelect from '../../../utilsTsx/components/hooks/GeneralMultiSelect';

const EditComponent = (props: any) => {
    const apiId = 'mqttMsg';
    const { defaultService } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [id, setId] = useState<string>();

    const [deviceData, setDeviceData] = useState<any>();
    const [topicData, setTopicData] = useState<any>();
    const [sendTargetData, setSendTargetData] = useState<any>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id } = res.data;
                setId(id);
            }
        });

        // 设备列表
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'device',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setDeviceData(res.data);
            }
        });

        // 主题列表
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'topic',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setTopicData(res.data);
            }
        });

        // 发送目标枚举
        fetchApi.GET(getService('bm'), {
            query: {
                apiId: 'generalData',
                apiVariable: 'sendTarget',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { sendTarget } = res.data;
                setSendTargetData(sendTarget);
            }
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'mf',
        displayOptions: {
            width: 900
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={10}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="ID"
                                    name="id"
                                    tooltip="主键，短 UUID，通常自动生成，仅用于系统内部关联与追溯。">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="发送目标"
                                    name="sendTargetId"
                                    tooltip="消息的发送方向，例如：设备、平台、广播等，来源于基础字典。用于区分上行/下行及广播消息。">
                                    <Select
                                        allowClear
                                        placeholder="请选择发送目标"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(sendTargetData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="发送设备"
                                    name="senderDeviceId"
                                    tooltip="发送消息所属设备。来源于“设备”表，用于关联具体设备与其 MQTT 通信记录。">
                                    <Select
                                        allowClear
                                        placeholder="请选择发送设备"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(deviceData, { itemName: 'deviceName' })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="接收设备"
                                    name="receiverDeviceId"
                                    tooltip="接收消息所属设备，可多台设备接收信息。">
                                    <GeneralMultiSelect
                                        placeholder="请选择接收设备">
                                        {getList.general(deviceData, { itemName: 'deviceName' })}
                                    </GeneralMultiSelect>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="主题id"
                                    name="topicId"
                                    tooltip="MQTT 主题（Topic），来源于“主题”表。用于标识消息的发布/订阅通道，如：device/+/report。">
                                    <Select
                                        allowClear
                                        placeholder="请选择主题"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(topicData, { itemName: 'topicName' })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="主题"
                                    name="topicStr"
                                    tooltip="MQTT 主题（Topic）">
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="创建"
                                    name={['sysDate', 'createdAt']}
                                    getValueProps={(value) => ({
                                        value: value ? dayjs(value) : undefined,
                                    })}
                                    normalize={(value) =>
                                        value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : undefined
                                    }
                                >
                                    <DatePicker
                                        showTime
                                        style={{ width: '100%' }}
                                        placeholder="请选择创建时间"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="更新"
                                    name={['sysDate', 'updatedAt']}
                                    getValueProps={(value) => ({
                                        value: value ? dayjs(value) : undefined,
                                    })}
                                    normalize={(value) =>
                                        value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : undefined
                                    }
                                >
                                    <DatePicker
                                        showTime
                                        style={{ width: '100%' }}
                                        placeholder="请选择更新时间"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="msgId"
                                    name="msgId">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col span={9}>
                                <Form.Item
                                    label="发送成功"
                                    name="isSendSuccess"
                                    valuePropName="checked"
                                    initialValue={false}>
                                    <Switch
                                        disabled={true}
                                        checkedChildren="成功"
                                        unCheckedChildren="失败" />
                                </Form.Item>
                            </Col>
                            <Col span={9}>
                                <Form.Item
                                    label="接收成功"
                                    name="isReceiveSuccess"
                                    valuePropName="checked"
                                    initialValue={false}>
                                    <Switch
                                        disabled={true}
                                        checkedChildren="成功"
                                        unCheckedChildren="失败" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="回复"
                                    name="replyMsg"
                                    tooltip="设备回复的消息，可为 JSON 字符串或纯文本。">
                                    <Input.TextArea
                                        rows={6}
                                        placeholder='如：{"cmd":"report","value":23.5}'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>

                    <Col span={14}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label=""
                                    name="originalMsg">
                                    <WangeditorV5ForAntD
                                        key={id}
                                        id={`mqttMsg${id}`}
                                        title='信息'
                                        displayMode='editor'
                                        defaultService={systematic.bmService}
                                        style={{ height: 300 }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label=""
                                    name="msg"
                                    tooltip="MQTT 消息，可为 JSON 字符串或纯文本。">
                                    <Input.TextArea
                                        rows={6}
                                        placeholder='如：{"cmd":"report","value":23.5}'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />);
};

export default EditComponent;